import { useAuth } from '../lib/auth';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ManagerAccessRegistry from '../components/manager/ManagerAccessRegistry';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield } from 'lucide-react';

export default function ManagerAccessPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { user, hasPermission } = useAuth();

    const canAccess = user?.role === 'super_admin' || user?.role === 'client_admin'
        || hasPermission?.('manage_manager_access');

    useEffect(() => {
        if (user && !canAccess) navigate('/');
    }, [user, canAccess, navigate]);

    if (!user || !canAccess) return null;

    return (
        <div className="space-y-6" data-testid="manager-access-admin-page">
            <div>
                <h1 className="text-2xl font-bold flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    <Shield className="w-6 h-6 text-fuchsia-500" />
                    {t('manager.registry')}
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                    {t('manager.manageAccess')}
                </p>
            </div>
            <Card>
                <CardHeader className="pb-3">
                    <CardTitle className="text-base">{t('manager.registry')}</CardTitle>
                </CardHeader>
                <CardContent>
                    <ManagerAccessRegistry
                        scope={{
                            organization_id: user.organization_id,
                            is_super_admin: user.role === 'super_admin',
                        }}
                    />
                </CardContent>
            </Card>
        </div>
    );
}
